export default __webpack_public_path__ + "navigation-examples-advanced-thumbnail-v1-960-839df0cd9a491342d040fceb3c29b048.webp";